import React, { Component } from 'react';
import classnames from 'classnames';
import {Col, Row} from 'react-bootstrap';
import Redux from 'redux';
import _ from 'underscore';
import ImageOrLettersView from './ImageOrLettersView';
import moment from 'moment';

class MessageListItemView extends Component {

    getTime(time) {
        time = moment(time);
        var isCurrentDate = time.isSame(new Date(), 'day');
        if (isCurrentDate) {
            return 'Today | ' + time.format('HH:mm');
        } else {
            return time.format('MMM D | HH:mm');
        }
    }

    render() {
        var message = this.props.message;
        var cx = classnames;
        var inboxMessageItemFullName = cx('inbox-message-full-name one-liner');
        let formatTime = this.getTime(message.created);

        return <Row className="inbox-message-item" key={this.props.index}>
            <Col className="inbox-message-image-wrapper" xs={3}>
                <div className={cx('hidden-xs', {'selected-mark color-1-background': this.props.isSelected})}/>
                <div className="inbox-message-image-container">
                    <div
                        className={cx('', {'unread color-1-background': !message.read && message.targetId == this.props.meId})}/>
                    <ImageOrLettersView image={message.person.photoUrl}
                        firstName={message.person.firstName}
                        lastName={message.person.lastName} shape="round-corners"/>
                </div>
            </Col>
            <Col className="" xs={9}>
                <div
                    className={inboxMessageItemFullName}>{message.person.firstName} {message.person.lastName}</div>
                <div className="inbox-message-body one-liner">{message.text}</div>
                <div className="inbox-message-time">{formatTime}</div>
            </Col>
        </Row>;
    }
}

export default MessageListItemView;

